export const FONT_SIZE_COOKIE = 'scale-font-size';
